import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './ProductManager.css';

import backArrowIcon from '../../assets/backarrow-icon.png';
import placeholderImage from '../../assets/placeholder-logo.png';
import api from '../../api';

function ProductManager({ user }) {
  const [products, setProducts] = useState([]);
  const [piToUsdRate, setPiToUsdRate] = useState(null);

  const navigate = useNavigate();

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const res = await api.get(`/products/by-business-username/${user.businessUsername}`);
        setProducts(res.data);

        const rateRes = await api.get('/convert/rate');
        setPiToUsdRate(rateRes.data.piToUsd || null);
      } catch (err) {
        console.error('❌ Failed to fetch products:', err);
      }
    };

    fetchProducts();
  }, [user.businessUsername]);

  return (
    <div className="productmanager-container">
      <div className="productmanager-header">
        <img
          src={backArrowIcon}
          alt="Back"
          className="productmanager-back-icon"
          onClick={() => navigate('/merchant/dashboard')}
        />
        <h2>My Products</h2>
      </div>

      <div className="productmanager-scroll">
        {products.length === 0 ? (
          <p className="no-products-msg">You haven’t added any products yet.</p>
        ) : (
          <div className="productmanager-list">
            {products.map((product) => (
              <div
                key={product._id}
                className="productmanager-card"
                onClick={() => navigate(`/product/${product._id}`)}
              >
                <img
                  src={product.media?.[0] || placeholderImage}
                  alt={product.name}
                  className="productmanager-img"
                />
                <div className="productmanager-info">
                  <p className="productmanager-name">{product.name}</p>


                  <p className="productmanager-price">
                    {product.pricingType === 'dynamic' && piToUsdRate
                      ? `${(product.usdPrice / piToUsdRate).toFixed(2)} Pi`
                      : `${product.price} Pi`}
                  </p>


                  <p className="productmanager-date">
                    {new Date(product.createdAt).toLocaleDateString()}
                  </p>


                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

export default ProductManager;
